/**
 * Cover Video Toggle Handler
 * Adds accessible play/pause buttons for cover block videos in Gutenberg blocks.
 * Uses Font Awesome styles and ensures ARIA accessibility attributes.
 */

document.addEventListener("DOMContentLoaded", () => {
	// Select all video elements inside `.wp-block-cover` blocks
	const coverVideos = document.querySelectorAll(".wp-block-cover video");

	coverVideos.forEach((video) => {
		const cover = video.closest(".wp-block-cover");

		// Ensure the toggle button is not already added
		if (cover && !cover.querySelector(".cover-video-toggle")) {
			// Create a play/pause button
			const btn = document.createElement("button");
			btn.className = "cover-video-toggle is-playing";
			btn.setAttribute("type", "button");
			btn.setAttribute("aria-label", "Pause background video");
			btn.setAttribute("aria-pressed", "false");
			btn.innerHTML =
				'<span class="visually-hidden">Pause background video</span>';

			// Append the button to the cover block
			cover.appendChild(btn);

			/**
			 * Toggle play/pause state of the video and update button attributes and classes.
			 */
			const toggleVideoState = () => {
				if (video.paused) {
					// Play the video
					video.play();
					btn.classList.remove("is-paused");
					btn.classList.add("is-playing");

					// Update ARIA attributes and text
					btn.setAttribute("aria-label", "Pause background video");
					btn.setAttribute("aria-pressed", "false");
					btn.innerHTML =
						'<span class="visually-hidden">Pause background video</span>';
				} else {
					// Pause the video
					video.pause();
					btn.classList.remove("is-playing");
					btn.classList.add("is-paused");

					// Update ARIA attributes and text
					btn.setAttribute("aria-label", "Play background video");
					btn.setAttribute("aria-pressed", "true");
					btn.innerHTML =
						'<span class="visually-hidden">Play background video</span>';
				}
			};

			// Attach the click event handler to toggle the video state
			btn.addEventListener("click", toggleVideoState);
		}
	});
});
